import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import useCouponCount from "../useCouponCount"
import useHasUnviewedWhatsNew from "../useHasUnviewedWhatsNew"
import Collapse from "./Collapse"
import ListItem from "./ListItem"
import NestedList from "./NestedList"

import couponBallon from "./couponBallon.png"
import img from "./myPageIcon.png"
import newIcon from "./new.png"

const SideBarNav = () => {
  const hasUnviewedWhatsNew = useHasUnviewedWhatsNew()
  const couponCount = useCouponCount() ?? 0

  return (
    <nav className={styles.nav}>
      <h3 className={styles.title}>
        <Image src={img} alt="" />
        マイページ
      </h3>
      <ul className={styles.list}>
        <ListItem href="/kiban/com/csComTop.do">マイページTOP</ListItem>
        <ListItem href="/kiban/com/csComWhatsNew.do">
          <div style={{ display: "flex", alignItems: "center" }}>
            お知らせ
            <Spacer size={4} />
            {hasUnviewedWhatsNew && <Image src={newIcon} alt="NEW" width={28} height={13} />}
          </div>
        </ListItem>
        <ListItem href="/kiban/com/csComCoupon.do">
          クーポン
          <Spacer size={2} />
          <Image src={couponBallon} alt="" width={43} height={22} />
          <span className={styles.couponCount}>{couponCount}枚</span>
        </ListItem>
        <Collapse title="ユーザー情報">
          <NestedList>
            <ListItem href="/kiban/com/csComShwUsr.do">ユーザー情報変更</ListItem>
            <ListItem href="/kiban/com/csComUpdPwd.do">パスワード変更</ListItem>
          </NestedList>
        </Collapse>
      </ul>
    </nav>
  )
}

export default SideBarNav

const styles = {
  nav: css`
    width: 200px;
  `,
  title: css`
    display: flex;
    align-items: center;
    height: 80px;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    background: linear-gradient(to bottom, #1c9622, #137817);
    > * {
      margin: 12px;
    }
  `,
  list: css`
    list-style: none;
    border: 1px solid #c3d0d8;
  `,
  couponCount: css`
    position: relative;
    left: -36px;
    width: 35px;
    font-size: 12px;
    font-weight: normal;
    color: #ed1e79;
    text-align: center;
  `,
}
